import type { FC } from 'react'
import { useState } from 'react'

import { MessagePopup } from '@skytech/ui'
import { Image } from '@skytech/ui/Image'

import { Translation } from '@/components/i18n/Translation'
import ChromeImg from '@/images/browsers/chrome.png'
import EdgeImg from '@/images/browsers/edge.png'
import IeImg from '@/images/browsers/ie.png'

import './ie-warning.scss'

const InternetExplorerWarning: FC = () => {
  const [isModalVisible, seIsModalVisible] = useState(true)
  // @ts-ignore
  const isIE = document.documentMode

  if (!isIE) return null

  return (
    <MessagePopup
      message={
        <Translation id="Vi anbefaler å bruke følgende nettlesere når du skal bestille mobiltelefoner, PC eller tilbehør i denne portalen" />
      }
      title={<Translation id="VIKTIG" />}
      type="warning"
      isOpen={isModalVisible}
      onClose={() => seIsModalVisible(false)}
    >
      <div className="ie-warning">
        <div className="browsers">
          <div>
            <Image src={ChromeImg} alt="chrome" />
            Google Chrome
          </div>

          <div>
            <Image src={EdgeImg} alt="edge" />
            Microsoft Edge
          </div>
        </div>

        <div className="ie">
          <Translation id="Internet Explorer er ikke lengre støttet og du kan derfor oppleve problemer ved bruk av denne." />
          <Image src={IeImg} alt="ie" />
        </div>
      </div>
    </MessagePopup>
  )
}

export default InternetExplorerWarning
